export { CarouselWithControls } from './carousel-with-controls.component'
export * from './carousel-with-controls'
